// Module
var code = "<cu-page-frame> <cu-page-frame-main> <cu-page-frame-content> <ng-transclude class=\"cu-d-flex cu-flex-column cu-w-100\"></ng-transclude> </cu-page-frame-content> </cu-page-frame-main> </cu-page-frame> ";
// Exports
module.exports = code;